// extracted by mini-css-extract-plugin
export var link = "toc-link-module--link--Fd-Fh";
export var ended = "toc-link-module--ended--ys2ZE";
export var active = "toc-link-module--active--m0DZW";